import { queryOptions, useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { Student } from '../modal/student';

export interface GetStudentByIdOptions {
  /** When true, active/scheduled enrollments in archived classes are included (studio). */
  includeArchivedEnrollments?: boolean;
}

export const getStudentById = async (
  studentId: string,
  options?: GetStudentByIdOptions,
) => {
  const response = await baseAPI.get<Student>(`/students/${studentId}`, {
    params:
      options?.includeArchivedEnrollments === true
        ? { includeArchivedEnrollments: true }
        : undefined,
  });
  return response.data;
};

export const getStudentByIdOptions = (
  studentId: string,
  options?: GetStudentByIdOptions,
) => {
  const includeArchived = options?.includeArchivedEnrollments === true;
  return queryOptions({
    queryKey: [KEYS.STUDENTS, studentId, includeArchived],
    queryFn: () => getStudentById(studentId, options),
    enabled: !!studentId,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};

export const useGetStudentById = (
  studentId: string,
  options?: GetStudentByIdOptions,
) => {
  return useQuery(getStudentByIdOptions(studentId, options));
};
